import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import { userDashboardViewEmploymentOnboardingRoute } from '#/modules/userDashboard/routing/userDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { UserDashboardEmploymentProfileOnboardingPageLoadable } from './UserDashboardEmploymentProfileOnboardingPageLoadable';

export async function loader(
  _: HorizonAppRouteLoaderArgs<
    typeof userDashboardViewEmploymentOnboardingRoute
  >,
) {
  await UserDashboardEmploymentProfileOnboardingPageLoadable.load();
}

export default function UserDashboardEmploymentProfileOnboardingHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Employment Profile')}>
      <UserDashboardEmploymentProfileOnboardingPageLoadable />
    </RouteModule>
  );
}
